// ==========================================================================
// HEADER THEME — Switches nav color when scrolling over light-theme sections
// (sections with data-header-theme="light", i.e. full-bleed cover images)
// ==========================================================================

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initHeaderTheme() {
  const nav      = document.getElementById('nav');
  const topbar   = document.getElementById('project-mobile-topbar');
  if (!nav) return;

  const sections = document.querySelectorAll('[data-header-theme="light"]');
  if (!sections.length) return;

  sections.forEach(section => {
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom top',
      onEnter:      () => { nav.classList.add('header--light');    topbar?.classList.add('header--light'); },
      onLeave:      () => { nav.classList.remove('header--light'); topbar?.classList.remove('header--light'); },
      onEnterBack:  () => { nav.classList.add('header--light');    topbar?.classList.add('header--light'); },
      onLeaveBack:  () => { nav.classList.remove('header--light'); topbar?.classList.remove('header--light'); },
    });
  });
}
